export interface IRefreshPageTemplatesRepository {
    execute(): Promise<void>;
}
